<template>
  <div class="students_up-page">
    <b-container>
      <b-row>
        <div class="breadcrumb">
          <div class="label">当前位置：</div>
          <div class="label">
            <span class="title" @click="to('/')">首页</span>
          </div>
          <div class="label" v-if="isMenu">
            <span class="icon"
              ><b-icon icon="chevron-right"></b-icon
              ><b-icon icon="chevron-right"></b-icon
            ></span>
            <span class="title" @click="navTo(isMenu, isMenu)">{{
              isMenu.name
            }}</span>
          </div>
          <div class="label" v-if="isMenu.children && menuKey">
            <template v-for="(item, index) in isMenu.children">
              <div
                v-if="item.id == menuKey"
                @click="navTo(item, isMenu)"
                :key="index"
              >
                <span class="icon"
                  ><b-icon icon="chevron-right"></b-icon
                  ><b-icon icon="chevron-right"></b-icon></span
                ><span class="title">{{ item.name }}</span>
              </div>
            </template>
          </div>
          <div class="label">
            <span class="icon"
              ><b-icon icon="chevron-right"></b-icon
              ><b-icon icon="chevron-right"></b-icon
            ></span>
            <span class="title">正文</span>
          </div>
        </div>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col :xl="3">
          <div class="left-navigation">
            <b-list-group>
              <b-list-group-item v-if="isMenu" style="background: #f9f9f9">
                {{ isMenu.name }}
              </b-list-group-item>
              <b-list-group-item
                v-for="(item, index) in isMenu.children"
                :key="index"
                @click="navTo(item, isMenu)"
                href="#"
                >{{ item.name }}</b-list-group-item
              >
            </b-list-group>
            <!-- 继续教育 -->
            <div class="jxjy">
              <img src="@/assets/img/advertising.png" />
            </div>
            <!-- 快速通道 -->
            <div class="kstd-block">
              <div class="title">
                <div class="icon">
                  <img src="@/assets/img/kuaisutongdao.png" />
                </div>
                快速通道
              </div>
              <div class="kstd" v-if="kstdList && kstdList.length > 0">
                <div
                  class="black"
                  v-for="(item, index) in kstdList"
                  :key="index"
                  @click="kstdTo(item)"
                >
                  <div class="img">
                    <img :src="baseURL + '/' + item.url" />
                  </div>
                  <div class="label">{{ item.name }}</div>
                </div>
              </div>
              <div class="kstd noData" v-else>无相关数据</div>
            </div>
          </div>
        </b-col>
        <b-col class="pl-0" :xl="9">
          <b-card>
            <div class="form-title">
              <h2>新生报名</h2>
            </div>
            <br />
            <b-form @submit="onSubmit">
              <b-form-group
                id="name"
                label="姓名:"
                label-cols="1"
                label-align="left"
                label-for="name"
              >
                <b-row>
                  <b-col cols="5">
                    <b-form-input
                      size="sm"
                      id="name"
                      :state="validateState('name')"
                      v-model="form.name"
                      placeholder="请输入姓名"
                      aria-describedby="name-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="name-feedback"
                      >姓名不能为空!</b-form-invalid-feedback
                    >
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                id="sex"
                label="性别:"
                label-cols="1"
                label-align="left"
                label-for="sex"
              >
                <b-form-radio-group v-model="form.sex" id="sex">
                  <b-form-radio :value="0">男</b-form-radio>
                  <b-form-radio :value="1">女</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group
                id="name"
                label="身份证号:"
                label-cols="1"
                label-align="left"
                label-for="name"
              >
                <b-row>
                  <b-col cols="5">
                    <b-form-input
                      size="sm"
                      id="userId"
                      v-model="form.userId"
                      placeholder="请输入身份证号"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                id="phone"
                label="手机号:"
                label-cols="1"
                label-align="left"
                label-for="phone"
              >
                <b-row>
                  <b-col cols="5">
                    <b-form-input
                      size="sm"
                      id="phone"
                      v-model="form.phone"
                      placeholder="请输入手机号"
                      aria-describedby="phone-feedback"
                      :state="validateState('phone')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="phone-feedback"
                      >手机号码不能为空或格式不正确!</b-form-invalid-feedback
                    >
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                id="faName"
                label="监护人:"
                label-cols="1"
                label-align="left"
                label-for="faName"
              >
                <b-row>
                  <b-col cols="5">
                    <b-form-input
                      size="sm"
                      id="faName"
                      v-model="form.faName"
                      placeholder="监护人"
                      aria-describedby="faName-feedback"
                      :state="validateState('faName')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="faName-feedback"
                      >监护人不能为空!</b-form-invalid-feedback
                    >
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                id="faPhone"
                label="监护人电话:"
                label-cols="1"
                label-align="left"
                label-for="faPhone"
              >
                <b-row>
                  <b-col cols="5">
                    <b-form-input
                      size="sm"
                      id="faPhone"
                      v-model="form.faPhone"
                      placeholder="监护人电话"
                      aria-describedby="faPhone-feedback"
                      :state="validateState('faPhone')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="faPhone-feedback"
                      >监护人电话不能为空或格式不正确!</b-form-invalid-feedback
                    >
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                id="name"
                label="专业:"
                label-cols="1"
                label-align="left"
                label-for="name"
              >
                <b-row>
                  <b-col cols="5">
                    <b-form-select
                      v-model="form.professionId"
                      :options="professionList"
                      value-field="id"
                      size="sm"
                      text-field="name"
                      options-field="children"
                      aria-describedby="professionId-feedback"
                      :state="validateState('professionId')"
                    >
                    </b-form-select>
                    <b-form-invalid-feedback id="professionId-feedback"
                      >请选择专业!</b-form-invalid-feedback
                    >
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                id="name"
                label="户籍地址:"
                label-cols="1"
                label-align="left"
                label-for="name"
              >
                <b-row>
                  <b-col cols="3">
                    <b-form-select
                      v-model="form.province"
                      :options="provinces"
                      size="sm"
                      text-field="label"
                      @change="province_change"
                    >
                    </b-form-select>
                  </b-col>
                  <b-col cols="3">
                    <b-form-select
                      v-model="form.city"
                      :options="citys"
                      size="sm"
                      text-field="label"
                      @change="city_change"
                    >
                    </b-form-select>
                  </b-col>
                  <b-col cols="3">
                    <b-form-select
                      v-model="form.area"
                      :options="areas"
                      size="sm"
                      @change="area_change"
                      text-field="label"
                    >
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                id="address"
                label="详细地址:"
                label-cols="1"
                label-align="left"
                label-for="address"
              >
                <b-row>
                  <b-col cols="5">
                    <b-form-input
                      size="sm"
                      id="address"
                      v-model="form.address"
                      placeholder="详细地址"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                id="email"
                label="邮箱地址:"
                label-cols="1"
                label-align="left"
                label-for="email"
              >
                <b-row>
                  <b-col cols="5">
                    <b-form-input
                      size="sm"
                      id="email"
                      v-model="form.email"
                      placeholder="邮箱地址"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-form-group>

              <div style="display: flex; justify-content: center">
                <div style="width: 6em">
                  <b-button block type="submit" variant="outline-primary"
                    >提交</b-button
                  >
                </div>
              </div>
            </b-form>
          </b-card>
          <br />
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="modal-1"
      title="提交成功"
      hide-header-close
      no-close-on-backdrop
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <b-img
          width="200px"
          :src="require('@/assets/img/WechatIMG141.png')"
        ></b-img>
        <div>打开微信扫一扫,了解第一资讯,以及进行缴费等...</div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          :disabled="!model_btn_disable.rc"
          variant="primary"
          @click="hide_modal"
          >知道了<span v-if="!model_btn_disable.rc"
            >{{ model_btn_disable.time }}S</span
          ></b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { request, baseURL } from "@/utils/http";
import { mapMutations } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  data() {
    return {
      baseURL,
      isMenu: this.$store.state.isMenu,
      menuKey: this.$store.state.menuKey,
      kstdList: this.$store.state.kstdList,
      form: {
        sex: 0,
      },
      professionList: [],
      provinces: require("@/utils/citys"),
      citys: [],
      areas: [],
      model_btn_disable: {
        time: 5,
        rc: true,
      },
    };
  },
  validations: {
    form: {
      name: { required },
      phone: { required, minLength: minLength(11) },
      sex: { required },
      professionId: { required },
      faName: { required },
      faPhone: { required, minLength: minLength(11) },
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
  },
  async created() {
    this.findProfessionList();
  },
  methods: {
    ...mapMutations(["upIsMenu", "upMenuKey"]),
    to(e) {
      this.$router.push(e);
    },
    kstdTo(e) {
      //快速通道点击事件
      if (e.type == 0 && e.path) {
        //内部链接
        this.$router.push(e.path);
      }
      if (e.type == 1 && e.path) {
        //外部链接
        window.open(e.path);
      }
      if (e.type == 2 && e.docxId) {
        //文章
        this.$router.push({
          name: "richText-id",
          params: { id: e.docxId },
        });
      }
    },
    navTo(e, item) {
      if (e.jump == 0) {
        this.upIsMenu(item);
        this.upMenuKey(e.id);
        if (e.type == 0 && e.path) {
          //内部链接
          this.$router.push(e.path);
        }
        if (e.type == 1 && e.path) {
          //外部链接
          window.open(e.path);
        }
        if (e.type == 2 && e.docxId) {
          //文章
          this.$router.push({
            name: "richText-id",
            params: { id: e.docxId },
          });
        }
        if (e.type == 3 && e.path) {
          //其他
          this.$router.push(e.path);
        }
      }
    },
    async findProfessionList() {
      const res = await request({
        url: `/we/ProfessionController/selectOfLevel`,
        method: "get",
        params: { pageNum: 1, pageSize: -1 },
      });
      if (res.code == 200) {
        this.professionList = res.data;
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const res = await request({
        url: `/web/UserController/register`,
        method: "post",
        data: this.form,
      });
      if (res.code == 200) {
        this.$bvModal.show("modal-1");
        this.model_btn_disable.rc = false;
        let interval = setInterval(() => {
          --this.model_btn_disable.time;
        }, 1000);
        setTimeout(() => {
          clearInterval(interval);
          this.model_btn_disable.rc = true;
          this.model_btn_disable.time = 5;
        }, 5000);
      } else {
        this.$bvToast.toast(res.message, {
          title: `error`,
          variant: "danger",
          noCloseButton: true,
          toaster: "b-toaster-top-center",
        });
      }
    },
    hide_modal() {
      this.$bvModal.hide("modal-1");
      this.form = {
        sex: 0,
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    province_change(e) {
      let data = this.provinces.find(function (item, index) {
        return item.value == e;
      });
      this.form["provinceName"] = data.label;
      this.form["city"] = null;
      this.form["cityName"] = null;
      this.form["area"] = null;
      this.form["areaName"] = null;
      this.areas = [];
      if (data.children) {
        this.citys = data.children;
      }
    },
    city_change(e) {
      let data = this.citys.find(function (item, index) {
        return item.value == e;
      });
      this.form["cityName"] = data.label;
      this.form["area"] = null;
      this.form["areaName"] = null;
      if (data.children) {
        this.areas = data.children;
      }
    },
    area_change(e) {
      let data = this.areas.find(function (item, index) {
        return item.value == e;
      });
      this.form["areaName"] = data.label;
    },
  },
};
</script>

<style lang="scss">
.students_up-page {
  .breadcrumb {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0;
    background: none;
    font-size: 16px;
    padding: 15px 0;
    .label {
      margin-right: 5px;
      .title {
        cursor: pointer;
      }
    }
    .icon {
      font-size: 10px;
      margin-right: 5px;
    }
  }
  .left-navigation {
    margin-bottom: 20px;
    .list-group-item {
      text-align: center;
    }
    .jxjy {
      margin-top: 15px;
      width: 100%;
      img {
        width: 100%;
      }
    }
    .kstd-block {
      margin-top: 15px;
      background: white;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 15px 15px 0 15px;
      overflow: hidden;
      .title {
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid $gray-4;
        padding-bottom: 5px;
        .icon {
          width: 18px;
          margin-right: 5px;
          display: inline-block;
          img {
            width: 100%;
          }
        }
      }
      .kstd {
        min-height: 220px;
        padding-bottom: 15px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        .black {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-top: 15px;
          .img {
            width: 60px;
            height: 60px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .label {
            padding-top: 10px;
            font-size: 12px;
            text-align: center;
          }
        }
        .black:hover {
          cursor: pointer;
          .label {
            color: $theme-5;
          }
        }
      }
    }
  }
  .form-title {
    text-align: center;
  }
}
</style> 